import { useSelector } from 'react-redux';
import { useQuery } from 'react-apollo';

import { MeQuery } from '../../../graphql/queries/account';

const useAccount = () => {
  const authenticated = useSelector(({ auth }) => auth.authenticated);
  const { data: { me } = {}, loading } = useQuery(MeQuery, {
    skip: !authenticated,
  });

  return {
    loading,
    account: me,
  };
};

export default useAccount;
